import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BlogList from './pages/BlogList';
import BlogEditor from './pages/BlogEditor';
import BlogPost from './pages/BlogPost';
import { useCreatePost, useUpdatePost } from './hooks/usePost';

export default function BlogRoutes() {
  const createPost = useCreatePost();
  const updatePost = useUpdatePost();

  return (
    <Routes>
      <Route path="/" element={<BlogList />} />
      <Route path="/new" element={<BlogEditor onSave={createPost.mutateAsync} />} />
      <Route path="/edit/:id" element={<BlogEditor onSave={updatePost.mutateAsync} />} />
      <Route path="/:slug" element={<BlogPost />} />
    </Routes>
  );
}